import { LOGO_URL, CONTACT } from "@/data/content";
import { useLanguage } from "@/i18n/LanguageContext";

const NAV_HREFS = ["#expertises", "#pourquoi", "#apropos", "#realisations", "#contact"];
const NAV_KEYS = ["expertises", "pourquoi", "apropos", "realisations", "contact"];

export default function Footer({ scrollTo }) {
  const { t } = useLanguage();
  return (
    <footer data-testid="site-footer" className="bg-slate-950 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="inline-block bg-white p-3 rounded-xl mb-5">
              <img src={LOGO_URL} alt="ACOMEP" className="h-9 w-auto" />
            </div>
            <p className="text-sm text-slate-400 leading-relaxed">
              {t.footer.tagline}
            </p>
          </div>

          <div>
            <div className="font-mono-tech text-[11px] tracking-[0.25em] uppercase text-white/40 mb-5">
              {t.footer.nav}
            </div>
            <ul className="space-y-3">
              {NAV_HREFS.map((href, i) => (
                <li key={href}>
                  <a
                    href={href}
                    onClick={(e) => {
                      e.preventDefault();
                      scrollTo(href);
                    }}
                    data-testid={`footer-link-${href.slice(1)}`}
                    className="text-sm text-slate-300 hover:text-[#E31E24] transition-colors"
                  >
                    {t.nav[NAV_KEYS[i]]}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="font-mono-tech text-[11px] tracking-[0.25em] uppercase text-white/40 mb-5">
              {t.footer.expertises}
            </div>
            <ul className="space-y-3">
              {t.expertise.domains.map((d, i) => (
                <li key={i}>
                  <a
                    href="#expertises"
                    onClick={(e) => {
                      e.preventDefault();
                      scrollTo("#expertises");
                    }}
                    data-testid={`footer-expertise-${i}`}
                    className="text-sm text-slate-300 hover:text-[#E31E24] transition-colors"
                  >
                    {d.title}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="font-mono-tech text-[11px] tracking-[0.25em] uppercase text-white/40 mb-5">
              {t.footer.coords}
            </div>
            <ul className="space-y-3 text-sm text-slate-300">
              <li>
                <a href={`mailto:${CONTACT.email}`} data-testid="footer-email" className="hover:text-[#E31E24] transition-colors">
                  {CONTACT.email}
                </a>
              </li>
              <li>
                <a href={CONTACT.phoneHref} data-testid="footer-phone" className="hover:text-[#E31E24] transition-colors">
                  {CONTACT.phone}
                </a>
              </li>
              <li>{CONTACT.location}</li>
              <li className="font-mono-tech text-xs tracking-[0.15em]">{CONTACT.tva}</li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <span className="font-mono-tech text-[11px] tracking-[0.2em] uppercase text-white/35">
            {t.footer.rights}
          </span>
          <span className="font-mono-tech text-[11px] tracking-[0.2em] uppercase text-white/35">
            {t.footer.made}
          </span>
        </div>
      </div>
    </footer>
  );
}
